import React from 'react';
import { Box, Skeleton } from '@mui/material';
import { useThemeContext } from '../../hook/useThemeManager';
import { theme } from '../../constants/theme';

interface IRoomItemSkeletonProps {
    showDivider?: boolean;
}

const RoomItemSkeleton: React.FC<IRoomItemSkeletonProps> = ({ showDivider = true }) => {
    const { themeStyle } = useThemeContext();

    return (
        <Box
            sx={{
                p: 2,
                display: 'flex',
                alignItems: 'center',
                borderBottom: showDivider ? `1px solid ${theme[themeStyle].grey}40` : 'none',
                bgcolor: 'transparent',
            }}>
            {/* Avatar skeleton */}
            <Skeleton variant="circular" width={40} height={40} sx={{ bgcolor: theme[themeStyle].deep_grey }} />

            {/* Content skeleton */}
            <Box sx={{ ml: 2, flex: 1 }}>
                {/* Name and time */}
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                    <Skeleton variant="text" width={120} height={24} sx={{ bgcolor: theme[themeStyle].deep_grey }} />
                    <Skeleton variant="text" width={50} height={20} sx={{ bgcolor: theme[themeStyle].deep_grey }} />
                </Box>

                {/* Message preview */}
                <Skeleton variant="text" width="80%" height={20} sx={{ bgcolor: theme[themeStyle].deep_grey }} />
            </Box>
        </Box>
    );
};

export default RoomItemSkeleton;
